import { Module } from 'vuex';

import { District } from 'qs_vuetify/src/types/models';
import { RootState } from 'qs_vuetify/src/types/states';

import { DistrictsRestState } from '@/types/states';

import {
  buildRestActions,
  buildRestGetters,
  buildRestMutations,
  buildRestState,
} from 'qs_vuetify/src/plugins/rest';

export const state: DistrictsRestState = buildRestState<District>('districts', {});

export const getters = buildRestGetters<District, DistrictsRestState>();

export const actions = buildRestActions<District, DistrictsRestState>();

export const mutations = buildRestMutations<District, DistrictsRestState>();

export const districts: Module<DistrictsRestState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
